import { customAxios } from "./customAxios"
export function searchMonitoring(key) {
    const config = {
        headers: {
            AuthToken: JSON.parse(localStorage.getItem('token')),
            'Content-Type': 'application/json'
        }
    }

    const data = JSON.stringify({
        "key": key
    })
    const searchRequest = customAxios.post(process.env.REACT_APP_BACKEND_HOST + "/adv/monitoraggio/search", data, config)
    return searchRequest
}